/*********************************************************************
 * © Copyright IBM Corp. 2022
 * Copyright © 2022 Randori https://randori.com - All Rights Reserved.
 *********************************************************************/
import debug from 'debug'

// ---------------------------------------------------------------------------

const log = debug('RANDORI:userType')

let userType: string | null = null

/** Updates the current user type */
export function setUserType(type: string) {
  userType = type
  log(`Setting userType to ${type}`)
}

/** Returns the current user type which defaults to unknown if null */
export function getUserType(): string {
  const currentUserType = userType ?? 'unset'
  log(`Fetching current userType ${currentUserType}`)
  return currentUserType
}

/** Clears the user type (reset to null) */
export function clearUserType() {
  userType = null
  log(`Clearing userType (resetting to null/unset)`)
}
